import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';

/**
 * URLから文字列・配列・null で渡されるパラメータを配列に正規化。
 * TanStack Router は検索パラメータに JSON.parse を適用するため、
 * ?key=null が JS の null として到達し得る。
 * 空配列 `[]` も `undefined` に正規化する（「フィルタなし」と同義）。
 */
const stringArraySchema = z.union([z.array(z.string()), z.string().transform(val => val ? [val] : []), z.null().transform(() => [])]).transform(arr => arr.length === 0 ? undefined : arr).optional();
export const TransfersSearchSchema = z.object({
  pageIndex: z.coerce.number().min(0).default(0),
  /**
   * 既定 50。このエンドポイントは件数にほぼ比例するため、既定 100 では
   * 実環境で 1 ページ 2.3 秒かかっていた（50 件なら約 1.1 秒）。
   * ユーザーはページネーションの「1ページあたり」から増やせる。
   * `docs/perf/organization-plan-phase0.md` の end-to-end 実測を参照。
   */
  pageSize: z.coerce.number().min(1).max(1000).default(50),
  /** API の departmentIds にマッピング */
  departmentIdIn: stringArraySchema,
  /** API の positionIds にマッピング */
  positionIdIn: stringArraySchema,
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional()
});